//import { ADOBE_TRACKING } from './adobeTracking';
import $ from 'jquery';
import commonStore from '../store/commonStore.js';
import shortid from 'shortid';
import { parseToBoolean } from '../utils/general/general';
import { ReadershipTrackingService } from './glassboxTracking';
import _ from 'lodash';

interface ISessionContext {
    authenticationType: string | undefined;
    deviceId: string;
    platformId: string;
    sessionId: string;
    vendorUserId: string | null;
    vendorUserType: string | null;
    cvUserId: string;
    crmUserId: string;
  }

export const RSCH_HTML_RENDITIONTRACKING = {
    log(module: string, msg: string) {
        console.log('|#|' + module + ":" + msg);
    },
    onReady: (function () {
        const _HTML_RENDITION: any = commonStore.getState().asyncStateReducer.initialData;
        const sessionContext: ISessionContext = commonStore?.getState().asyncStateReducer?.sessionContext?.data?.sessionContext;
        _HTML_RENDITION.dimensionAndMetricsBase = {
            'dimension1': _HTML_RENDITION.doc_id,
            'dimension4': _HTML_RENDITION.channel,
            'dimension5': _HTML_RENDITION.sub_channel,
            'dimension6': _HTML_RENDITION.user_type,
            'dimension7': _HTML_RENDITION.parent_doc_id || "",
            'dimension8': _HTML_RENDITION.forced_loginId.toLowerCase(), // partner_id || masked_CRM_id || CRM_id
            'dimension16': _HTML_RENDITION.platform,
            'dimension17': _HTML_RENDITION.requestid,
            'dimension79': _HTML_RENDITION.device_id || "",
            'dimension18': _HTML_RENDITION.user_id.toLowerCase(), // masked_CRM_id || CRM_id
            'dimension21': _HTML_RENDITION.isEmbargoed,
            'dimension80': updatePartnerId(),
            'dimension81': navigator.userAgent,
            'dimension82':sessionContext?.sessionId,
        };

        if (_HTML_RENDITION.isEmbargoed == "M") {
            _HTML_RENDITION.dimensionAndMetricsBase['dimension8'] = _HTML_RENDITION.embargoedForcedLoginId;
            _HTML_RENDITION.dimensionAndMetricsBase['dimension18'] = _HTML_RENDITION.embargoedUserId;
            _HTML_RENDITION.dimensionAndMetricsBase['dimension80'] = _HTML_RENDITION.embargoedPartnerId;
        }
    }),
    publishPiwikEvent(piwikEvent: any) {
        const _HTML_RENDITION: any = commonStore.getState().asyncStateReducer.initialData;
        // Don't send events to piwik if "doReadership" is false
        if (_HTML_RENDITION.doReadership == 'false') {
            return;
        }

        if (piwikEvent.trackingType === 'defaultTrack' || piwikEvent.trackingType === 'customTrackingCall') {
            try {
                // piwik(piwikEvent.eventType, piwikEvent.trackingType, piwikEvent.trackingContextInfo);
                piwik(piwikEvent);
            } catch (e) {
            }
        }
        const dimAndMetricsPage = {};
        $.extend(true, dimAndMetricsPage, _HTML_RENDITION.dimensionAndMetricsBase);

        // Adobe Analytics
        // try {
        //     ADOBE_TRACKING.linkTracking(piwikEvent);
        //     return;
        // }
        // catch (e) { }
        // return;
        // Piwik
        // deletedelete piwikEvent.trackingData.additionalInfo.eventLabel;

    },
    conditionalConsoleLogger() {
        let consoleDebug = true;

        try {
            if (!console || !console.log) {
                consoleDebug = false;
            }
        } catch (err) {
            consoleDebug = false;
        }

        const consoleLogIt = function (thearg: any) {
            if (consoleDebug) {
                console.log(thearg);
            }
        };
    },
    piwikCustomTrackingData(piwikTrackingEventType: any, eventType: any, additionalInfo: any) {
        try {
            // validation
            if (!eventType) {
                throw new Error(
                    'eventType is not defined. Cannot instantiate PiwikCustomTrackingData');
            }
            if (additionalInfo && !(typeof (additionalInfo) == "object"))
                throw new Error(
                    'additionalInfo should be an object. Cannot instantiate PiwikCustomTrackingData');
            if (isNaN(piwikTrackingEventType)) {
                throw new Error(
                    'piwikTrackingEventType is not defined. Cannot instantiate PiwikCustomTrackingData');
            }
            return $.extend(additionalInfo, extendTrackingContextObject());
        } catch (e: any) {
            console.log(`Error in instantiation of PiwikCustomTrackingData:${e}`);
            if (e.stack) console.log(e.stack);
        }
    },
    piwikTrackingEventTypeEnum: {
        PAGE: 0,
        NON_PAGE: 1
    },
    trackerInit(siteId: string, opt_env: string) {
        _.delay(()=>{
            
        if ((window as any).piwikTracking) {
            console.log('Got the PIWIK min file');
            (window as any).piwikTracking.init(siteId, opt_env);
        } else {
            console.log("Couldn't find the piwikTracking in piwik JS file");
        }

        },1000)
    }
};

const piwik = function (piwikEvent: any) {
    try {
        const self: {[k: string]: any} = {};
        if (piwikEvent.trackingType === "defaultTrack") {
            defaultTrack(piwikEvent.eventType,self, piwikEvent.trackingContextInfo, piwikEvent.piwikTrackingEventType,piwikEvent.visibleComponentIdList);
        } else if (piwikEvent.trackingType === "bindTrackingContext") {
            bindTrackingContext(self, piwikEvent.eventType,piwikEvent.trackingContextInfo);
        } else if (piwikEvent.trackingType === "customTrackingCall") {
             customTrackingCall(piwikEvent.piwikTrackingEventType, self, piwikEvent.eventType,piwikEvent.trackingData, piwikEvent.eventAction, piwikEvent?.subPageId, piwikEvent?.pageTrackingData?.componentName, piwikEvent?.eventDataId, piwikEvent?.eventDataType, piwikEvent?.visibleUIComponentIds);
        } else {
            console.log(piwikEvent.trackingType);
        }

    } catch (e: any) {
        console.log("Error in jq-piwik action:" + e);
        if (e.stack) console.log(e.stack);
    }
};

const customTrackingCall = function (piwikTrackingEventType: any, elem: any, eventType: any, additionalInfo: any, eventAction: string, subPageId?: string, actionComponent?: string, eventDataId?: string, eventDataType?: string, visibleUIComponentIds?: any) {
    const _HTML_RENDITION: any = commonStore.getState().asyncStateReducer.initialData;
    if (!eventType)
        console.log(`!!!!!!!!!!!!!customTracking call with no eventType specified. tracking call should be aborted: ${getElemIdentifier(elem)}`);
    let piwikContext = {};
    piwikContext = _getInferredTrackingContextItems(elem);
    const mergedContext = _extendTrackingContext1With2(piwikContext, additionalInfo);
    let docId = "UNKNOWN";
    let userId = "UNKNOWN";
    try {
        docId = _HTML_RENDITION.doc_id;
        userId = _HTML_RENDITION.user_id;
    } catch (error) { }
    _makePiwikTrackingCall(piwikTrackingEventType, eventType, "0", getElemIdentifier(elem), mergedContext, docId, userId, additionalInfo, eventAction, subPageId, actionComponent, eventDataId, eventDataType, visibleUIComponentIds);
};

const _getInferredTrackingContextItems = function (elem: any) {
    // Returning empty object, because we don't want anything appeneded before in the json.
    return {};

    // doubt this hops an iframe, so if that is a case, it needs to be dealt with
    let elemId = getElemIdentifier(elem);
    if (elem == document)
        elemId = "#document";
    // ditto re: iframe above
    let path = _getContainerPath(elem);
    if (path.length > 20) path = path.substring(0, 19);
    const eventVersion = 1;
    const retObj: any = new Object();
    retObj["elemId"] = elemId;
    retObj["path"] = path;
    retObj["eventVersion"] = eventVersion + "";
    return retObj;
};

const _extendTrackingContext1With2 = function (obj1: any, obj2: any) {
    return $.extend({}, obj1, obj2);
};

const _getContainerPath = function (elem: any) {
    const ancestors: any = [];
    $(elem).parents().not('html').each(function () {
        let entry = this.tagName.toLowerCase();
        if (this.id) {
            entry += ("#" + this.id);
        }
        if (this.className) {
            entry += "." + this.className.replace(/ /g, '.');
        }
        ancestors.push(entry);
    });
    ancestors.reverse();
    return ancestors.join("____");
};

const defaultTrack = function (eventType: string, elem: any, contextInfo: any, piwikTrackingEventType: any, visibleComponentIdList: any) {
    if (eventType === "click") {
        $(elem).click(function () {
            _defaultTrackingCall(elem, eventType, piwikTrackingEventType,contextInfo,'');
        });
    } else if (eventType === "ready") {
        $(elem).ready(function () {
            _defaultTrackingCall(elem, eventType, piwikTrackingEventType,contextInfo, visibleComponentIdList);
        });
    } // else
};

const bindTrackingContext = function (elem: any, eventType: string, trackingContextObject: any) {
    $(elem).data('piwikContext_' + eventType, trackingContextObject);
};

const _defaultTrackingCall = function (elem: any, eventType: any, piwikTrackingEventType: any, contextInfo: any, visibleComponentIdList: any) {
    const _HTML_RENDITION: any = commonStore.getState().asyncStateReducer.initialData;
    // check contxt bound, else eject
    /* const piwikContext = _getTrackingContext(elem, eventType);
    console.log('piwikContext -> '+piwikContext);
    if (!piwikContext)
        return; */

    // uses default context set at init
    console.log(`piwik defaultTrackingCall for: ${getElemIdentifier(elem)}  :  ${eventType} :    ${JSON.stringify(contextInfo)}`);

    let docId = "UNKNOWN";
    let userId = "UNKNOWN";
    try {
        const sessionContext =  commonStore?.getState().asyncStateReducer?.sessionContext?.data?.sessionContext;
        docId = _HTML_RENDITION.doc_id;
        userId = _HTML_RENDITION.user_id || sessionContext?.cvUserId;
    } catch (error) { }

    _makePiwikTrackingCall(piwikTrackingEventType, eventType, "0", getElemIdentifier(elem), contextInfo, docId, userId,"","","","","","",visibleComponentIdList);
};

const _getTrackingContext = function (elem: any, eventType: any) {
    const retObj = $(elem).data('piwikContext_' + eventType);
    if (!retObj) {
        console.log("!!!!!!!!!!!!!no tracking context vars available, tracking call should be aborted:" + getElemIdentifier(elem));
        return null;
    } else {
        return retObj;
    }
};

const getElemIdentifier = function (elem: any) {
    if (elem.id) {
        return elem.id;
    } else if (elem.className) {
        return elem.className;
    } else return "";
};

const _verifyCvar4Length = function (piwikContext: any) {
    return JSON.stringify(piwikContext);
};

const _makePiwikTrackingCall = function (piwikTrackingEventType: any, eventType: any, trackingSource: any, componentId: any, piwikContext: any, docID: any, userId: any,preferredContextItemsToRetain: any, eventAction?: string | undefined | unknown, subPageId?: string |undefined, actionComponent?: string, eventDataId?:string, eventDataType?:string, visibleComponentIdList?:any,) {
    try {
        
          const sessionContext =  commonStore?.getState().asyncStateReducer?.sessionContext?.data?.sessionContext;
        const _HTML_RENDITION: any = commonStore.getState().asyncStateReducer.initialData;
        const internalEnumMap: any = {
            "userId": "0",
            "docId": "1",
            "elemId": "2",
            "path": "3",
            "eventVersion": "4",
            "docCtx": "5",
            "author": "6",
            "timeOnPage": "7",
            "coords": "8"
        };

        const reverseMap: any = {};

        for (const prop in internalEnumMap) {
            if (internalEnumMap.hasOwnProperty(prop)) {
                reverseMap[internalEnumMap[prop]] = prop;
            }
        }

        const getVal = function (key: string) {
            if (internalEnumMap[key]) {
                return internalEnumMap[key];
            } else {
                return key;
            }
        };

        const getReverseVal = function (val: string) {
            if (reverseMap[val]) {
                return reverseMap[val];
            } else {
                return val;
            }
        };
        const eventInstanceId = shortid.generate();
        const newPiwikContext: any = {};
        for (const aProp in piwikContext) {
            if (aProp)
                newPiwikContext[getVal(aProp)] = piwikContext[aProp];
        }
        newPiwikContext["RenditionType"] = _HTML_RENDITION.renditionDocumentType || 'null';
        newPiwikContext["eventInstanceId"] = eventInstanceId;
        const campaignInfo = $("#campaignLink0");
        // console.log('$("#campaignLink0").attr("data-name")'+$("#campaignLink0").attr("data-name"));
        if (campaignInfo) {
            newPiwikContext["CampaignId"] = $("#campaignLink0").attr("data-name");
        }
        if (piwikTrackingEventType == RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.PAGE) {
            newPiwikContext["eventAction"] = 'PAGE_LOAD';
        }

        if(newPiwikContext?.componentName === 'Record Timing' || window.HTML_RENDITION.isMultimediaPage) {
            try {
            newPiwikContext["prevEventInstanceId"] = sessionStorage?.getItem('prevEventInstanceId');
            } catch(e) {
                console.error(e);
            }
        }

        const verifiedForLengthContext_stringified = _verifyCvar4Length(newPiwikContext);
        let cvUrl;
        let cvUrlDetails;
        let cvLandingPage;
        let cvLandingPageDetails;
        try {
            cvUrl = ((window.location != window.parent.location) ? window.parent.location.href : document.location.href);
            cvUrlDetails = ((window.location != window.parent.location) ? window.parent.location.href : document.location.href).split('/');
            cvLandingPage = cvUrlDetails[5];
        } catch (e) {
            const currentUrl = window.location.href;
            if (currentUrl.indexOf("vendor-issue") >= 0) {
                cvUrl = window.location.href;
                cvUrlDetails = window.location.href.split('vendor-issuer=');
                cvLandingPageDetails = cvUrlDetails[1].split('#/');
                cvLandingPage = cvLandingPageDetails[0];
            }
            console.log("catch-block:Exception in getting parent doc details", e);
        }
        console.log("cvUrl :: " + cvUrl);
        console.log("cvUrlDetails :: " + cvUrlDetails);
        const crm_id = _HTML_RENDITION.maskedContactID != null ? atob(_HTML_RENDITION.maskedContactID) : "";
        updatePartnerId();
        let menuCodeForEvent = "";
        if (preferredContextItemsToRetain && preferredContextItemsToRetain.HLCC)
            menuCodeForEvent = preferredContextItemsToRetain.HLCC;

        let menuNavigationPathForEvent = "";
        if (preferredContextItemsToRetain && preferredContextItemsToRetain.componentName)
            menuNavigationPathForEvent = preferredContextItemsToRetain.componentName;

        const trackingJSONdata = {
            "customVariable":
                [
                    {
                        "properties": (piwikTrackingEventType == RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.PAGE ?
                            {
                                "partner_id": _HTML_RENDITION.partner_login || 'null', "sourceId": _HTML_RENDITION.parent_doc_id || 'null', "platform": _HTML_RENDITION.platform,
                                "userIdType": _HTML_RENDITION.user_type, "AuthenticationType": _HTML_RENDITION.authenticationType || sessionContext?.authenticationType, "CV_LANDING_PAGE": cvLandingPage || 'null', "CV_LANDING_PAGE_REFERRER_URL": cvUrl, "RENDITION_REFERRER_URL": _HTML_RENDITION.referer || 'null',
                                              "TRANSFORMED_PLATFORM_LOGIC": _HTML_RENDITION.transformed_platform_logic || _HTML_RENDITION.transformed_platform_case, "CRM_ID": crm_id,
                                              "LINK_ID": _HTML_RENDITION.linkId || 'null', "LINK_ID_CREATE_TIME": _HTML_RENDITION.linkIdCreateTime || 'null', "LINK_ID_EXPIRY_TIME": _HTML_RENDITION.linkIdExpiryTime || 'null',
                                              "vendor_request_id": _HTML_RENDITION.vendor_request_id,"MENU_ITEM_ID": _HTML_RENDITION.menuItemId,
                                              "COUNTRY": _HTML_RENDITION.country,"UUID": shortid.generate(),"CUSTOMER_SEGMENT":_HTML_RENDITION.customerSegment,"BANKER": parseToBoolean(_HTML_RENDITION.valid_vendor_banker)
                            } :
                            {
                                "partner_id": _HTML_RENDITION.partner_login || 'null', "sourceId": _HTML_RENDITION.parent_doc_id || 'null', "eventName": eventType, "platform": _HTML_RENDITION.platform,
                                "userIdType": _HTML_RENDITION.user_type, "AuthenticationType": _HTML_RENDITION.authenticationType || sessionContext?.authenticationType, "CV_LANDING_PAGE": cvLandingPage || 'null', "CV_LANDING_PAGE_REFERRER_URL": cvUrl, "RENDITION_REFERRER_URL": _HTML_RENDITION.referer || 'null',
                                              "TRANSFORMED_PLATFORM_LOGIC": _HTML_RENDITION.transformed_platform_logic || _HTML_RENDITION.transformed_platform_case, "CRM_ID": crm_id,
                                              "LINK_ID": _HTML_RENDITION.linkId || 'null', "LINK_ID_CREATE_TIME": _HTML_RENDITION.linkIdCreateTime || 'null', "LINK_ID_EXPIRY_TIME": _HTML_RENDITION.linkIdExpiryTime || 'null',
                                              "vendor_request_id": _HTML_RENDITION.vendor_request_id,"MENU_ITEM_ID": _HTML_RENDITION.menuItemId,
                                              "COUNTRY": _HTML_RENDITION.country,"UUID": shortid.generate(),"CUSTOMER_SEGMENT":_HTML_RENDITION.customerSegment,"BANKER": parseToBoolean(_HTML_RENDITION.valid_vendor_banker)
                            })
                    },
                    {
                        "trackingSource": (piwikTrackingEventType == RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.PAGE ? "5" : "100")
                    },
                    {
                        "menuCode": (piwikTrackingEventType == RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.PAGE ?
                            window.HTML_RENDITION.isMultimediaPage ? 'RENDITION_MULTIMEDIA_Open' : "HTML_Document_Open" : menuCodeForEvent)
                    },
                    {
                        "someVar4": verifiedForLengthContext_stringified
                    },
                    null,
                    null,
                    {
                        "contentId": _HTML_RENDITION.doc_id
                    },
                    {
                        "contentSourceId": _HTML_RENDITION.contentSourceId ? _HTML_RENDITION.contentSourceId : "2"
                    }
                ],
            "trackingData":
            {
                "idSite": "70",
                "menuNavigationPath": (piwikTrackingEventType == RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.PAGE ?
                    "HTML/Document Open" : menuNavigationPathForEvent),
                "loginId": (_HTML_RENDITION.partner_login != null ? _HTML_RENDITION.partner_login : _HTML_RENDITION.user_id)
            }

        };
       _.delay(()=>{
        if ((window as any)?.piwikTracking) {
            (window as any).piwikTracking.trackData(piwikTrackingEventType, trackingJSONdata);
            
        // Glassbox API call started!!
        try{
            console.log("Glassbox API call strarted");
           
            ReadershipTrackingService.glassboxTracking(trackingJSONdata, eventAction, subPageId, actionComponent,crm_id, eventDataId, eventDataType, visibleComponentIdList)
            console.log("Successfully Glassbox API called");
        }
        catch (e) {
            console.log("Exception raised calling Glassbox API " + e);
        }
        } else {
            console.log("Couldn't find the piwikTracking in piwik JS file");
        }
       },1000)

    } catch (e) {
        console.log("docOpen", "catch-block");
        console.log("docOpen:catch-block", e);
    }

};

const updatePartnerId = function () {
    const _HTML_RENDITION: any = commonStore.getState().asyncStateReducer.initialData;
    if (_HTML_RENDITION.gcifId){
        _HTML_RENDITION.partner_login = _HTML_RENDITION.gcifId;
    } else {
        const valid_platform_ids_str = _HTML_RENDITION.alt_userids_readership?.replace(/['"]+/g, '');
        const valid_platform_ids = valid_platform_ids_str?.split(",");
        for (let id = 0; id < valid_platform_ids?.length; id++) {
            if (_HTML_RENDITION.platform === valid_platform_ids[id]) {
                _HTML_RENDITION.partner_login = _HTML_RENDITION.user_id.toLowerCase();
                break;
            }
        }
    }
    return _HTML_RENDITION.partner_login;
};

const extendTrackingContextObject = function () {
    const _HTML_RENDITION: any = commonStore.getState().asyncStateReducer.initialData;
    const sessionContext: ISessionContext = commonStore?.getState().asyncStateReducer?.sessionContext?.data?.sessionContext;
    if (_HTML_RENDITION.platform == '100') {
        return {
            "requestId": _HTML_RENDITION.requestid,
            "partner_id": updatePartnerId(),
            "email_send_id": _HTML_RENDITION.emailSendId || 'null',
            "authentication_id": _HTML_RENDITION.user_id,
            "mode": _HTML_RENDITION.mode || 'null',
            "deviceId": _HTML_RENDITION.device_id || _HTML_RENDITION.deviceId,
            "channel": _HTML_RENDITION.copyUrlChannel,
            "subChannel": _HTML_RENDITION.copyUrlSubChannel,
            "vendor": _HTML_RENDITION.copyUrlVendor,
            "portalEnvironment": _HTML_RENDITION.portalEnvHeader || _HTML_RENDITION['x-portal-env'],
            "userAgent": navigator.userAgent,
            'sessionId': sessionContext?.sessionId,
            'shareItSendId': _HTML_RENDITION.shareItSendId || 'null'
        };
    } else {
        return {
            "requestId": _HTML_RENDITION.requestid,
            "partner_id": updatePartnerId(),
            "email_send_id": _HTML_RENDITION.emailSendId || 'null',
            "authentication_id": _HTML_RENDITION.user_id,
            "mode": _HTML_RENDITION.mode || 'null',
            "deviceId": _HTML_RENDITION.device_id || _HTML_RENDITION.deviceId,
            "channel": _HTML_RENDITION.channel,
            "subChannel": _HTML_RENDITION.sub_channel,
            "portalEnvironment": _HTML_RENDITION.portalEnvHeader || _HTML_RENDITION['x-portal-env'],
            "userAgent": navigator.userAgent,
            'sessionId': sessionContext?.sessionId,
            'shareItSendId': _HTML_RENDITION.shareItSendId || 'null'
        };
    }
};

export default RSCH_HTML_RENDITIONTRACKING;
